// «Con il primo operatore disponibile» nella scheda del centro corrente: il cambio centro
// dal calendario unificato (o il ritorno all'origin dal pannello) ha azzerato l'operatore
// scelto, perché nel centro raggiunto non lavora. Senza un operatore scelto non è cambiato
// nulla, quindi non c'è niente da ricordare.
export const getAnyUserPointOfSaleId = (
  pointOfSaleId: string,
  isUserReset: boolean,
  hadUser: boolean
): string | undefined => (isUserReset && hadUser ? pointOfSaleId : undefined);

// Il ricordo vale finché si resta nel centro raggiunto e il cliente non sceglie di nuovo un
// operatore; altrimenti la scheda non deve più dirlo
export const getActiveAnyUserPointOfSaleId = (
  anyUserPointOfSaleId: string | undefined,
  currentPointOfSaleId: string,
  hasUser: boolean
): string | undefined =>
  anyUserPointOfSaleId === currentPointOfSaleId && !hasUser
    ? anyUserPointOfSaleId
    : undefined;
